/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { createRef, useEffect, useState, useMemo } from "react";
import GoogleModelViewer from "../../../components/GoogleModelViewer";
import FabricSelection from "./FabricSelection";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  fabricAtom,
  modelAtom,
  tabAtom,
  uploadImageAtom,
  showModalAtom,
  beforeSelectedImageScaletom,
  selectedCustomFabricAtom,
  addNewCustomFabricAtom,
  addFabricBeforeAtom,
  currentPillowStateAtom,
  selectedPartAtom,
  addFabricToggleAtom,
  selectedProductAtom,
  selectedFabricBandAtom,
} from "../../../state";
import PillowModelViewer from "../../../components/GoogleModelViewer/PillowModelViewer";
import CropImage from "../../../components/CropImage";
import { categoryCustomisation } from "../../../lib/categoryWiseCustomisation";
import { Spinner } from "reactstrap";
import { ImageGlobalUrl } from "../../../lib/constant";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Slider, Spin } from "antd";
import { DebounceInput } from "react-debounce-input";
import Cropper from "react-cropper";
import RelatedProducts from "../Products/RelatedProducts";
import CustomizeHeader from "../../../components/CustomizeHeader";
import { useNavigate, useParams } from "react-router-dom";

const Customization = ({ category, productData, selectedProduct }) => {
  const { id } = useParams();
  const [tab, setTab] = useRecoilState(tabAtom);
  const [fabricAtomState, setFabricsAtomState] = useRecoilState(fabricAtom);
  const [selectedPart, setSelectedPart] = useRecoilState(selectedPartAtom);
  const [modelAtomValue] = useRecoilState(modelAtom);
  const [inputSetValue, setInputSetValue] = useRecoilState(
    beforeSelectedImageScaletom
  );
  const [selectedCustomFabric, setSelectedCustomFabricAtom] = useRecoilState(
    selectedCustomFabricAtom
  );
  const [showModal, setShowModal] = useRecoilState(showModalAtom);
  const addFabricBefore = useRecoilValue(addFabricBeforeAtom);
  const [cropData, setCropData] = useState(addFabricBefore[selectedPart?.name]);
  const [addNewCustomFabric, setAddNewCustomFabric] = useRecoilState(
    addNewCustomFabricAtom
  );
  const cropperRef = createRef();

  const [addFabricToggle, setAddFabricToggle] =
    useRecoilState(addFabricToggleAtom);
  // const currentCategoryTitle = productData?.storeSubCategories?.[0]?.title;
  const [, setCurrentPillowState] = useRecoilState(currentPillowStateAtom);
  const [uploadImage, setUploadImage] = useRecoilState(uploadImageAtom);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 990);
  const [selectedProductObj] = useRecoilState(selectedProductAtom);
  const navigate = useNavigate();

  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 990);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (productData?.name) {
      setCurrentPillowState((prev) => ({ ...prev, name: productData.name }));
    }
    if (productData?.sku) {
      setCurrentPillowState((prev) => ({ ...prev, sku: productData.sku }));
    }
  }, [productData]);
  const closeHandler = () => {
    setShowModal(false);
    setAddFabricToggle(false);
  };
  const onCrop = () => {
    const cropper = cropperRef.current?.cropper;
    const imgData = cropper?.getCroppedCanvas().toDataURL();
    setUploadImage({
      ...uploadImage,
      [selectedPart?.name]: imgData,
    });
    if (selectedCustomFabric?.id) {
      const newData = addNewCustomFabric?.map((data) =>
        data?.id === selectedCustomFabric?.id ? { ...data, imgData } : data
      );
      setAddNewCustomFabric(newData);
    }
  };
  useEffect(() => {
    if (productData?.parts?.length > 0 && !selectedPart) {
      const firstCustomizablePart = productData.parts.find(
        (p) => p.isCustomize
      );
      if (firstCustomizablePart) {
        setSelectedPart(firstCustomizablePart);
      }
    }
  }, [productData, id]);

  useEffect(() => {
    setCurrentPillowState((prev) => ({
      ...prev,
      partWiseFabric: fabricAtomState?.partWiseFabric,
    }));
  }, [fabricAtomState]);

  useEffect(() => {
    if (selectedPart) {
      const matched = categoryCustomisation?.filter((item) =>
        selectedPart?.materialCategory?.includes(item.parentId)
      );
      if (
        matched?.length > 0 &&
        matched[0]?.name !== fabricAtomState.currentMaterial?.name
      ) {
        setFabricsAtomState((prev) => ({
          ...prev,
          currentMaterial: matched[0],
        }));
      }
    }
  }, [
    selectedPart,
    categoryCustomisation,
    // fabricAtomState.currentMaterial?.name,
  ]);

  useEffect(() => {
    if (addFabricBefore[selectedPart?.name]) {
      setCropData(addFabricBefore[selectedPart?.name]);
    }
  }, [addFabricBefore]);

  const UseHeightAndWidth = async () => {
    if (uploadImage?.[selectedPart?.name]) {
      const final_img = uploadImage?.[selectedPart?.name];
      var image = new Image();
      image.src = final_img;
      await image.decode();
      if (selectedCustomFabric?.id) {
        setAddNewCustomFabric(addNewCustomFabric);
      }
    }
  };

  useEffect(() => {
    UseHeightAndWidth();
  }, [uploadImage]);

  useEffect(() => {
    setTab("TAB_1");
  }, [category]);

  const materialCategory = useMemo(
    () => [fabricAtomState?.currentMaterial?.parentId],
    [fabricAtomState?.currentMaterial?.parentId]
  );
  const subMaterialCategory = useMemo(
    () => [fabricAtomState?.currentMaterial?.subMaterialId],
    [fabricAtomState?.currentMaterial?.subMaterialId]
  );

  const getPartImage = (part) => {
    if (part.name.toLowerCase() === "backrest") {
      return "/parts/Backrest.svg";
    } else if (part.name.toLowerCase() === "structure") {
      return "/parts/structure.svg";
    } else if (part.name.toLowerCase().includes("pillow")) {
      return "/parts/pillow.svg";
    } else if (part.name.toLowerCase().includes("base")) {
      return "/parts/base.svg";
    } else if (part.name.toLowerCase().includes("leg")) {
      return "/parts/leg.svg";
    } else if (part.name.toLowerCase().includes("seat")) {
      return "/parts/seat.svg";
    } else if (part.name.toLowerCase().includes("top")) {
      return "/parts/top.svg";
    }
    return "/border.svg";
  };

  const loadCategoryCustomizationTab = () => {
    return (
      <ul>
        {
          productData?.parts
          ?.filter((part) => part?.showInShare)
          ?.length && <div onClick={() => navigate("/")} className="bg-lightGray cursor-pointer py-2 hidden lg:flex items-center justify-center">Choose</div>
        }
        
        {productData?.parts
          ?.filter((part) => part?.showInShare)
          ?.map((part, index) => {
            const tabId = `TAB_${index + 1}`;
            const isActive = tab === tabId;
            const isSamePart = selectedPart?.partId === part?.partId;
            return (
              <li
                key={tabId}
                className={isActive ? "active" : ""}
                onClick={() => {
                  if (!isActive || !isSamePart) {
                    setTab(tabId);
                    setShowModal(false);
                    setAddFabricToggle(false);
                    setSelectedPart(part);
                    setFabricsAtomState({
                      ...fabricAtomState,
                      currentPart: part?.parts || [],
                    });
                  }
                }}
              >
                <img
                  src={getPartImage(part)} // Default image, you can make this dynamic
                  className="w-[45px] h-[45px]"
                  alt={`${part.name} selection`}
                />
                <p className="tab-text mb-0 mt-2 text-center">{part?.name}</p>
              </li>
            );
          })}
      </ul>
    );
  };
  const [, setSelectedFabricBand] = useRecoilState(selectedFabricBandAtom);

  const renderDynamicContent = () => {
    const matchedMaterials =
      categoryCustomisation?.filter((item) =>
        selectedPart?.materialCategory?.includes(item.parentId)
      ) || [];

    const selectedFabric =
      fabricAtomState?.partWiseFabric[fabricAtomState.currentPart[0]];
    const getCheckSupport = localStorage.getItem("checkSupport");
    const base64Image =
      selectedFabric?.finish?.search("data:image") !== -1 ? true : false;
    const uploadNewImage = base64Image
      ? selectedFabric?.finish
      : `${ImageGlobalUrl}/${
          getCheckSupport && window?.webpSupport
            ? selectedFabric?.finish?.replaceAll(".jpg", ".webp")
            : selectedFabric?.finish
        }`;
    return (
      <div className="p-4">
        {!addFabricToggle && (
          <>
            {fabricAtomState.currentPart.length > 0 &&
            selectedPart &&
            productData ? (
              <div className="border-bottom mb-4 w-83 mobile-none">
                <div className="d-flex align-items-center pb-3 w-100">
                  <div className="small-box">
                    {uploadNewImage ? (
                      <img src={uploadNewImage} alt="" className="h-full" />
                    ) : (
                      <img src="/defalutImage.jpg" alt="" className="h-full" />
                    )}
                  </div>
                  <div className="w-100 ms-2 mb-0">
                    <p className="font-14 text-black mb-0">
                      {selectedFabric?.name || "Select Material"}
                    </p>
                  </div>
                  {base64Image && selectedFabric && (
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        setSelectedFabricBand("FABRIC");
                        setAddFabricToggle(true);
                      }}
                    >
                      Edit
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <Spin className="black-spinner" />
            )}

            {/* Material Type Selection */}
            <div
              className={`align-items-center flex-wrap ${
                matchedMaterials?.length > 1 ? "d-flex" : "d-none"
              }`}
            >
              {matchedMaterials?.map((matchedMaterial, index) => {
                if (!matchedMaterial) return null;
                const isActive =
                  fabricAtomState.currentMaterial?.name ===
                  matchedMaterial.name;
                return (
                  <div
                    key={index}
                    onClick={() => {
                      setFabricsAtomState((prev) => ({
                        ...prev,
                        currentMaterial: matchedMaterial,
                      }));
                    }}
                    className={`side-box me-3 mb-3 position-relative ${
                      isActive ? "active" : ""
                    }`}
                  >
                    {/* <img
                      src={"/default-material.png"} // You can customize based on matchedMaterial.image if you have it
                      alt=""
                      className="side-img"
                    /> */}
                    <p className="font-14 text-center mb-0 text-gray-500">
                      {matchedMaterial?.name}
                    </p>
                  </div>
                );
              })}
            </div>
          </>
        )}
        {addFabricToggle && (
          <div className="p-4">
            <div>
              <div
                className={` me-3 position-relative mb-3 d-flex justify-content-end `}
              >
                <div
                  className="cursor-pointer text-black"
                  onClick={() => closeHandler()}
                >
                  X
                </div>
              </div>
              <div className="mt-3">
                <p className="mb-0 color-gray">Scale</p>
                <Form.Group as={Row} className="w-100 align-items-center m-0">
                  <Col xs="9" className="pl-0">
                    <Slider
                      min={0}
                      max={2}
                      defaultValue={1}
                      onChange={(val) => {
                        if (Number(val) <= 2) {
                          setInputSetValue({
                            ...inputSetValue,
                            [selectedPart?.name]: {
                              ...inputSetValue[selectedPart?.name],
                              Scale: val,
                            },
                          });
                          setSelectedCustomFabricAtom({
                            ...selectedCustomFabric,
                            Scale: val,
                          });
                        }
                      }}
                      value={selectedCustomFabric.Scale || 1}
                      step={0.1}
                    />
                  </Col>
                  <Col xs="3" className="p-0">
                    <DebounceInput
                      type="number"
                      min={0}
                      max={2}
                      className={`search-control w-100`}
                      placeholder={"Scale"}
                      defaultValue={1}
                      autoComplete="off"
                      value={inputSetValue?.[selectedPart?.name]?.Scale || 1}
                      debounceTimeout={500}
                      onChange={(e) => {
                        if (Number(e.target.value) <= 2) {
                          setInputSetValue({
                            ...inputSetValue,
                            [selectedPart?.name]: {
                              ...inputSetValue[selectedPart?.name],
                              Scale: Number(e.target.value),
                            },
                          });
                          setSelectedCustomFabricAtom({
                            ...selectedCustomFabric,
                            Scale: Number(e.target.value),
                          });
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </div>
              <div className="mt-3">
                <div className="d-flex justify-content-between">
                  <p>Preview</p>
                </div>
                <div>
                  <div>
                    <div>
                      <Cropper
                        ref={cropperRef}
                        className="w-full h-full"
                        zoomTo={0}
                        zoomable={false}
                        initialAspectRatio={1}
                        preview=".img-preview"
                        src={cropData}
                        viewMode={1}
                        minCropBoxHeight={10}
                        minCropBoxWidth={10}
                        background={false}
                        responsive={true}
                        autoCropArea={0.5}
                        checkOrientation={false}
                        guides={true}
                        crop={onCrop}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <Form.Group as={Row} className="mt-5">
                <Col xs="6">
                  <Button
                    className=" w-100 w-min-126px"
                    size="lg"
                    variant="primary"
                    type="submit"
                    onClick={() => closeHandler()}
                  >
                    Apply
                  </Button>
                </Col>
                <Col xs="6">
                  <Button
                    className=" w-100 w-min-126px border border-black bg-white"
                    size="lg"
                    variant="light"
                    type="submit"
                    onClick={() => closeHandler()}
                  >
                    Cancel
                  </Button>
                </Col>
              </Form.Group>
            </div>
          </div>
        )}
        {!addFabricToggle &&
          fabricAtomState?.currentMaterial?.parentId &&
          fabricAtomState?.currentMaterial?.subMaterialId && (
            <FabricSelection
              pillowSide={selectedPart?.name} // You can make this dynamic if needed
              materialCategory={materialCategory}
              subMaterialCategory={subMaterialCategory}
              selectedPart={selectedPart?.name}
              // header={fabricAtomState.currentMaterial?.name?.toUpperCase()}
              header="FABRIC"
            />
          )}
      </div>
    );
  };

  return (
    <>
      <CustomizeHeader
        showCloseButton={false}
        text={`${productData?.sku || productData?.uniqueCode || ""} ${
          selectedProductObj?.name || ""
        }`}
      />
      {(productData?.sku || productData?.uniqueCode) && (
        <RelatedProducts skuId={productData?.sku || productData?.uniqueCode} />
      )}
      <div className="product-title text-center w-100">
        DESIGNER CUSTOMIZATION
      <div className="text-center text-sm w-100 ">Click icon to make selection</div>
      </div>
      <div className="product-info-row container-fluid">
        {showModal ? (
          <CropImage selectedPart={selectedPart?.name} />
        ) : (
          <div className="row ">
            <div className="col-lg-6 col-xl-6 left-part mt-rem-6 mt-0 d-flex justify-content-between flex-col">
              {modelAtomValue.src ? (
                category === "pillow" ? (
                  <PillowModelViewer />
                ) : (
                  <GoogleModelViewer />
                )
              ) : (
                ""
              )}
            </div>
            <div className="col-lg-6 col-xl-6 right-part text-left mobile-shadow">
              {productData?.parts?.length < 0 ? (
                <div className="py-8">
                  <Spinner />
                </div>
              ) : (
                <div
                  className={`d-flex align-items-stretch tab-item-wrapper ${
                    isMobile && "pl-5"
                  }`}
                >
                  
                  {loadCategoryCustomizationTab()}
                  <div
                    className={`item-infos me-4 ${
                      isMobile ? "w-full" : "w-[70%]"
                    }`}
                  >
                    <div className="tab-content">{renderDynamicContent()}</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Customization;
